export const RESPONSE_CODES = {
  ACCESS_TOKEN_EXPIRED: "", // Todo: ask backend for the correct code
  REFRESH_TOKEN_EXPIRED: "" // Todo: ask backend for the correct code
} as const;
